module.exports = __webpack_public_path__ + "static/media/googleLogo.2bc4d9dd.svg";